<!-- FIXME: This can use a confirm dialog instead of existing. -->
<template>
    <Modal class="cash-up-confirm-modal"
           icon="fa-calculator"
           title="CASH_UP.CONFIRM_TITLE">
        <p>
            {{ l('CASH_UP.CONFIRM_TEXT') }}
        </p>
        <p>
            <strong>{{ l('CASH_UP.TOTAL_TEXT') }} {{ currencyFilter(total) }}</strong>
        </p>
        <template v-slot:footer>
            <div class="modl-footer">
                <SquareBtn color="danger"
                           size="lg"
                           class="cancel-btn"
                           @click="cancel">
                    {{ l('CASH_UP.GO_BACK') }}
                </SquareBtn>
                <SquareBtn color="success"
                           size="lg"
                           @click="resolve">
                    {{ l('CONFIRM') }}
                </SquareBtn>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from '@/vue/components/Modals/Modal';
import SquareBtn from '@/vue/components/SquareBtn';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    components: { SquareBtn, Modal },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        total: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="less">
@import (reference) "../../../../less/variables";

.cash-up-confirm-modal {
    p {
        margin: @half-gutter-width !important;
        font-size: @font-size-large;
    }
}
</style>
